export function createArrowHeadSegments (start, end, length = 18, angle = Math.PI / 7) {
  const theta = Math.atan2(end.y - start.y, end.x - start.x)
  const tip = {x: end.x, y: end.y}
  const left = {
    x: end.x - length * Math.cos(theta + angle),
    y: end.y - length * Math.sin(theta + angle),
  }
  const right = {
    x: end.x - length * Math.cos(theta - angle),
    y: end.y - length * Math.sin(theta - angle),
  }

  return [
    [tip, left],
    [tip, right],
  ]
}



// WEBPACK FOOTER //
// ./src/views/question-review/components/AnswerFileFullScreen/src/drawArrow.js